import React from 'react';
import Checkout from '../components/Checkout/index';

function CheckoutPage() {
    return <Checkout />;
}

export default CheckoutPage;
